<div popper [validate]="formControl">
  <ng-select id="select"
             [placeholder]="placeholder"
             [bindLabel]="bindLabel"
             [bindValue]="bindValue"
             appendTo="body"
             [items]="items"
             [searchable]="searchable"
             [multiple]="multiple"
             [hideSelected]="hideSelected"
             [clearable]="clearable"
             [disabled]="disabled"
             [ngModel]="value"
             (search)="onSearch($event)"
             (ngModelChange)="change($event)">
  </ng-select>
</div>
<ng-container *ngIf="multiple && items">
  <cloud-tags class="d-block mt-2"
              [bindLabel]="bindLabel"
              [bindValue]="bindValue"
              [items]="items"
              [(selected)]="value"
              (selectedChange)="change($event)">
  </cloud-tags>
</ng-container>
